import { Component, OnInit , ViewChild} from '@angular/core';
import {WorkGroup} from './workgroup'
import {NgForm, FormsModule} from '@angular/forms';
import {WorkgroupService} from '../workgroup-services/workgroup.service'
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../shared/services/auth/auth.service'
import {VisitorComponent} from '../visitor/visitor.component'
import {DeletePopupComponent} from '../../organization/Popups/delete-popup/delete-popup.component'
import { MatDialog, MatSnackBar} from '@angular/material';
import { StaticValueService } from '../../shared/services/static-value.service'
import {AssociateService} from '../../shared/services/associate.service'
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { ToastService } from '../../shared/services/toast.service'
import * as moment from 'moment'
import { Jsonp } from '../../../../node_modules/@angular/http';
import { Configuration } from '../../app.constants';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class DetailComponent implements OnInit {

  @ViewChild('myForm')
  public isFormSubmit:Boolean=false;
  public myForm: NgForm ;
  public group;
  public show = false;
  public associates: any;
  public search: String;
  public dropdown;
  public groupid: any;
  public user: any;
  public title: String='';
  public oldMember={'fullName':'','startDate':'','endDate':'','role':'','status':false}
  public addedAssociates:any = [];
  public associate:any;
  public Coordinator:any=0;
  public Chair:any=0;
  public chairMember: any = {personalInformation: ''} ;
  public coordinatorMember: any = {personalInformation: ''} ;
  public errors: any;
  public selfmemberAdded: Boolean =false;
 public action = {type: 'Workgroup',
              message: '', actionUrl: '', receiverID: '',
              category: 'Approval' , avatarUrl: '', status: 'Unread',
              acceptValue: 'Approved', rejectValue: 'Disapproved', objectID: ''}
  public serverApiUrl;            

  constructor( 
    public service: WorkgroupService,
    public route: ActivatedRoute,
    public auth: AuthService,
    public router: Router,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public staticDDListService: StaticValueService,
    public associateService:AssociateService,
    public mobileNav: MobileNavService,
    public tosterService:ToastService,
    public config: Configuration
  ) { }

  ngOnInit() {
    // this.associates = Object.assign([], this.route.snapshot.data['associates']);
  //   this.associateService.getAllAssociates(0, 10).subscribe((data) => {
  //     this.associates = data;
  //   }, (err) => {
  // });
  this.serverApiUrl = this.config.StaticImageUrl;
  this.dropdown = this.staticDDListService.staticData['staticDD']['workingGroup']
  this.errors = this.staticDDListService.errors;
    this.user = this.auth.user;
    this.group = Object.assign({}, WorkGroup);
    this.group.requestedDate = new Date();
    this.group.startDate = new Date();

    if (this.user.associateId) {
      this.associateService.getAssociate(this.user.associateId).subscribe(associate => {
        // this.addMember(associate[0])
        this.associate = JSON.parse(JSON.stringify(associate['data'][0]));
      });
    }

    this.associateSearch();
  }
  // create new work group
  createWorkGroup() {
      // if (this.Chair < 1 || this.Coordinator < 1) {
      //   this.tosterService.error(this.errors.Workgroup['401']);
      //   return;
      // }else
      this.group.hrId = this.associate.jobDescription.hrManager.id;

      this.addChairAndCoordinator(this.coordinatorMember);
      this.oldMember.fullName = undefined;
      this.addChairAndCoordinator(this.chairMember);
      this.oldMember.fullName = undefined;
      this.group.Members[0].isUpdate = false;
      this.group.Members[0].role = 'Chair';
      this.group.Members[1].isUpdate = false;
      this.group.Members[1].role = 'Coordinator';
      if ( this.isFormSubmit) {
        this.tosterService.error(this.errors.Workgroup['402']);
        // this.snackBar.open('Please wait system is processing', '', {duration: 2000});
        return;
      }
      // tslint:disable-next-line:max-line-length
      if(!this.group.endDate){
        this.group.groupStatus = 'Active'      
      } else if (moment(this.group.startDate).diff(moment(), 'days') <=0  && moment().diff(moment(this.group.endDate), 'days') <= 0 ) {
        this.group.groupStatus = 'Active'
      } else {
        this.group.groupStatus = 'Inactive';
      }
  

      this.isFormSubmit = true;
      this.group.lastEditedBy.push({name: this.user.isProxyUser ? this.user.name + ` (${this.user.proxyUser.fullName})` : this.user.name, id: this.user.associateId, time: new Date()})
      if ( this.user.role === 'Super Admin' || this.user.role === 'Admin') {
        this.group.approval = 'Approved';
      }
      this.service.createWorkGroup(this.group).subscribe((data) => {
        var g = {
          'workingGroupId': data['_id'],
          'alias': this.group.groupAlias,
          'description': this.group.description,
          'status': this.group.groupStatus,
          'scope': this.group.scope,
          'startDate': this.group.startDate,
          'endDate': this.group.endDate,
          'approval': this.group.approval,
          'privacy': this.group.privacySetting,
          'groupType' : this.group.groupType,
          'membersCount' : this.group.Members.length
        }
        this.group =JSON.parse(JSON.stringify(data));

        this.associate.workGroupsAndCommittees.push(g);
        this.associateService.updateAssociateWorkingGroup(this.associate).subscribe(res => {
          console.log('success', res)
        }, error => {
          console.log(error)
        });

        if (this.user.role === 'Super Admin' || this.user.role === 'Admin') {
          this.isFormSubmit = false;
          this.appovedWorkgroup(g);
          // this.group.Members.forEach(member => {
          //   if(member.associateId !== this.user.associateId) {
          //     this.service.addToNotification(member.associateId, member.role, this.group.groupAlias, this.user.name, data['_id']);
          //   }
          // });
          this.tosterService.success();
          this.router.navigate(['/home/working-group/search']);
          return;
        }
        this.action.receiverID = this.associate.jobDescription.hrManager.id;
        this.action.actionUrl = `/home/working-group/profile-hr/${data['_id']}`
        this.action.objectID = data['_id'];
        // tslint:disable-next-line:max-line-length
        this.action.message = `Workgroup <span class='fw-bold d-inline'>${this.group.groupAlias}</span> created by <span class='fw-bold d-inline'>${this.user.isProxyUser ? this.user.name + ` (${this.user.proxyUser.fullName})` : this.user.name}</span> on <span class='fw-bold d-inline'>${moment(this.group.reqestedDate).format('DD MMM YYYY')}</span> requires your approval. Click here to proceed to approval page.`
        this.service.sendValidationAction(this.action);

        
      // display snackbar
        this.isFormSubmit=false;
        this.tosterService.success();
        // this.snackBar.open('New Workgroup Added', '', {duration: 2000});        
        this.router.navigate(['/home/working-group/search']);
      },
      (error) => {
        this.isFormSubmit=false;
        this.tosterService.error(this.errors.Server["501"]);        
        // this.snackBar.open(this.errors.Server["501"], '', {duration: 2000,});        
      });
  }
  //
  Next(){
    // console.log('days',moment(this.group.startDate).diff(moment(), 'days') , moment(this.group.endDate  ).diff(moment(), 'days') )
    // if (!this.show && this.group.Members.length === 0) {
      // this.addMember(this.associate);
    // }
    if(this.group.Members.length ===0 && !this.selfmemberAdded){
      this.addMember(this.associate);
      this.selfmemberAdded = true;
    }
    this.show = !this.show;
    // this.addMember(this.associate)
  }
  // remove member
  removeMember(_member:any){
    let dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '300px',
      data: {
      title:`You want to remove '${_member.fullName}' ?`
      },    
    });
    dialogRef.afterClosed().subscribe(res=>{
      if(res=='Proceed'){
        console.log('WorkGroup Remove member', _member);
        console.log(this.group.Members.indexOf(_member,1));
        this.group.Members.splice(this.group.Members.indexOf(_member),1);
        console.log(this.group.Members);
      }
    })

  }

// add new member to work group
  addMember(associate: any) {

    if(associate._id=== this.chairMember._id || associate._id===this.coordinatorMember._id){
      return;
    }

    this.associates = this.associates.filter(associ => {
      if (associate !== associ) {
        return associ;
      }
    })

    if (this.oldMember.fullName) {
      this.tosterService.error(`First save ${this.oldMember.fullName}`);
      return;
    }

    if (!associate) {
      return;
    }

    let newMember = {
      'fullName' : associate.personalInformation.fullName,
      'associateId': associate._id,
      'jobTitle': associate.jobDescription.jobTitle,
      'designation': associate.jobDescription.company.name,
      'designationID':associate.jobDescription.company.id,
      'email' : associate.workContactDetails.workEmail,
      'startDate' : this.group.startDate,
      'endDate' : this.group.endDate,
      'role' : 'Member',
      'status' :  (moment(this.group.startDate).diff(moment(), 'days') <=0  && moment().diff(moment(this.group.endDate), 'days') <= 0) || !this.group.endDate,
      'contactNumber' : associate.workContactDetails.workMobile,
      'landLineNumber': associate.workContactDetails.workLandline,
      'isUpdate' : false,
      'imageUrl': associate.personalInformation.avatarUrl
    }


    let isMember = false;
    if (this.addedAssociates) {
      this.group.Members.filter(added => {
        if (added.associateId === associate._id) {
          isMember = true;
          return;
        }
      });
    }
    if (isMember){
        // display snackbar
        this.snackBar.open(`'${newMember.fullName}' already a member`, '', {duration: 2000, });
        return;
        }

      this.updateMember(newMember);

    if (this.group.Members.length > 0){
      this.group.Members.unshift(newMember)
    // display snackbar
      this.snackBar.open(`New Member '${newMember.fullName}' Added`, '', {duration: 2000, });
      this.addedAssociates.push(associate)
    }
    else{
      // newMember.role = 'Coordinator';
      this.group.Members = [newMember]
      this.addedAssociates = [associate];
    }
    // if(newMember.role==='Coordinator'){
    //   this.Coordinator+=1;
    // }else if( newMember.role==='Chair'){
    //   this.Chair+=1;
    // }
  }



  addChairAndCoordinator(associate){
    let newMember = {
      'fullName' : associate.personalInformation.fullName,
      'associateId': associate._id,
      'jobTitle': associate.jobDescription.jobTitle,
      'designation': associate.jobDescription.company.name,
      'designationID':associate.jobDescription.company.id,
      'email' : associate.workContactDetails.workEmail,
      'startDate' : this.group.startDate,
      'endDate' : this.group.endDate,
      'role' : 'Member',
      'status' :  (moment(this.group.startDate).diff(moment(), 'days') <=0  && moment().diff(moment(this.group.endDate), 'days') <= 0) || !this.group.endDate,
      'contactNumber' : associate.workContactDetails.workMobile,
      'landLineNumber': associate.workContactDetails.workLandline,
      'isUpdate' : false,
      'imageUrl': associate.personalInformation.avatarUrl
    }

    if (this.group.Members.length > 0){
      this.group.Members.unshift(newMember)
      this.addedAssociates.push(associate)
    }
    else{
      // newMember.role = 'Coordinator';
      this.group.Members = [newMember]
      this.addedAssociates = [associate];
    }
  }




  // add visitor in the members
  addExternalMember() {
    const dialogRef = this.dialog.open(VisitorComponent, {
      width: '500px',
      data: {
      group: this.group
      },
    });

    dialogRef.afterClosed().subscribe(visitor => {
      if (visitor !== undefined) {
        if (this.oldMember.fullName) {
          this.tosterService.error(`First save ${this.oldMember.fullName}`);
          return;
        }else {
          this.group.Members.unshift(visitor);
          this.updateMember(visitor);
        }
      }
    });
  }

  // Member is need update
  updateMember(member: any) {
    if (!this.oldMember.fullName) {
      this.makecopy(this.oldMember, member)
      member.isUpdate = true;
    }
    else {
      this.tosterService.error(`First save ${this.oldMember.fullName}`);
      // this.snackBar.open(`First Update ${this.oldMember.fullName}`, ' ', {duration: 2000, });
    }

  }

  acceptUpdatedMember(member: any) {
//   this.makecopy(member,this.oldMember)

    member.status =(moment(member.startDate).diff(moment(), 'days') <=0  && moment().diff(moment(member.endDate), 'days') <= 0) || !member.endDate;

    if(member.role==='Coordinator'){
      this.Coordinator+=1;
    }else if (member.role==='Chair') {
        this.Chair+=1;
    }
    if(this.oldMember.role==='Coordinator'){
      this.Coordinator-=1;
    }else if (this.oldMember.role==='Chair'){
      this.Chair-=1;
    }
    this.oldMember = {'fullName' : '', 'startDate': '', 'endDate': '', 'role': '', 'status': false};
    member.isUpdate = false;
  }

  cancelUpdatedMember(member: any) {
    this.makecopy(member, this.oldMember)
    this.oldMember = {'fullName': '', 'startDate': '', 'endDate': '', 'role': '', 'status': false};
  }

  makecopy(to: any, from: any){
    to.fullName = from.fullName;
    to.startDate = from.startDate;
    to.endDate = from.endDate;
    to.role = from.role,
    to.status = from.status;
    to.isUpdate = from.isUpdate;
  }


  associateSearch() {

    this.associateService.getAllAssociatesFilter(this.search, '', '').subscribe(data => {
      this.associates = Object.assign([],undefined);
       Object.assign([], data).forEach(element => {
        console.log('index of ', this.addedAssociates.indexOf(element))
        // tslint:disable-next-line:max-line-length
        if (this.addedAssociates.indexOf(element) === -1 && element._id !== this.chairMember._id && element._id !== this.coordinatorMember._id  ) {
           this.associates.push(element);
        }
      });
    })
  }

  appovedWorkgroup(g: any) {

    this.group.lastEditedBy.unshift({name: this.user.isProxyUser ? this.user.name + ` (${this.user.proxyUser.fullName})` : this.user.name, id: this.user.associateId, time: new Date()})    
    g.membersCount = this.group.Members.length;
    this.group.Members.filter(member => {
      if (member.associateId && member.associateId !== this.user.associateId) {
        this.associateService.getAssociate(member.associateId).subscribe(associate => {
          if (associate['data'][0]['workGroupsAndCommittees']) {
            associate['data'][0]['workGroupsAndCommittees'].push(g);
          } else {
            associate['data'][0]['workGroupsAndCommittees'] = [g]
          }
          this.associateService.updateAssociateWorkingGroup(associate['data'][0]).subscribe(res => {
          }, error => {
          });
        });
        this.service.sendMail(member, this.group, 0).then(res => {});
      }
    });
  }
  onClickMe() {
    this.mobileNav.showSideNav();
 }
}
